import * as React from 'react';
import './index.scss';
import { fetch, RankItem, GetAuditionRankRsp } from '@/fetch.ts';
import AnchorItem from '@hooks/web/public/anchorItem.tsx';
import Page from '@hooks/web/public/page.tsx';
import None from '@hooks/web/public/none.tsx';
import RankHeader from '@hooks/web/public/rankHeader.tsx';
const { useEffect, useState } = React;

interface Props {
  iArea: number,
  iStage: number,
}

const RichRank: React.FC<Props> = props => {
  const [list, List] = useState<RankItem[]>([]);
  const [showListTop3, ShowListTop3] = useState<RankItem[]>([]);
  const [showList, ShowList] = useState<RankItem[]>([]);
  const [pageShow, PageShow] = useState<boolean>(true);

  const isLast = props.iStage === 4 // 第4阶段是决赛
  const numberBase = isLast ? 5 : 10;

  const pageChange = (index: number): void => {
    ShowList(list.slice((index) * numberBase, (index + 1) * numberBase >= list.length ? list.length : (index + 1) * numberBase));
  }
  useEffect(() => {
    PageShow(false);
    fetch.GetAuditionRank(
      {
        iActId: 20201202,
        iStage: props.iStage,
        iAreaId: props.iArea,
      },
    )
      .then((rsp: GetAuditionRankRsp) => {
        console.log('游戏/娱乐榜', {
          iActId: 20201202,
          iStage: props.iStage,
          iAreaId: props.iArea,
        }, rsp);
        PageShow(true);
        ShowListTop3(rsp.tPanel.vRankList.value.slice(0, 3))
        List(rsp.tPanel.vRankList.value.slice(isLast ? 3 : 0, isLast ? 25 : 50));
        ShowList(rsp.tPanel.vRankList.value.slice(isLast ? 3 : 0, isLast ? 25 : 50).slice(0, isLast ? 5 : 10));
      })
  }, [props.iStage])
  const bgPic = props.iArea > 1 ? 'web-gameRank web-yuleRank' : 'web-gameRank'
  const bgPics = props.iArea > 1 ? 'web-gameRank-last yule' : 'web-gameRank-last'
  return (
    <div className="web-gameRank-box">
      {
        isLast ?
          <div className={bgPics}>
            <div className='game-List'>
              <div className="top-3">
                <ul>
                  {
                    showListTop3.map((item: RankItem, idx: number) => (
                      <li className='top3' key={idx} idx={idx}>
                        <div className="img">
                          <img src={item.sLogoUrl} onClick={(): void => {
                            window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank');
                          }} />
                          <i className="icon"></i>
                        </div>
                        <p>
                          <b>{item.sNickName}</b>
                          <span>星光值{item.lScore}</span>
                        </p>
                      </li>
                    ))
                  }
                </ul>
              </div>
              {
                showList.length === 0 ?

                  <div style={{ marginTop: '100px' }}><None text={'暂无数据'} /></div>
                  :
                  showList.map((item: RankItem) => (
                    <AnchorItem
                      key={item.tJump.lPid}
                      width={860}
                      {...item}
                      small={false}
                    />
                  ))
              }
            </div>
            {
              pageShow &&
              <div className='web-pageCover'>
                <Page
                  pageLen={list.length % 5 === 0 ? list.length / 5 : Math.floor(list.length / 5) + 1}
                  setPageIndex={pageChange}
                />
              </div>
            }
          </div>
          : <div
            className={bgPic}
          >
            <div className='game-List'>
              {
                showList.length === 0 ?
                  <div className="noneData"><None text={'暂无数据'} /></div>
                  :
                  <div>
                    <RankHeader
                      width={855}
                      color='#ffefbf'
                      prev='排名'
                      mid='主播昵称'
                      next={'星光'}
                    />
                    {
                      showList.map((item: RankItem) => (
                        <AnchorItem
                          key={item.tJump.lPid}
                          width={860}
                          {...item}
                          small={false}
                        />
                      ))
                    }
                  </div>

              }
            </div>
            {
              pageShow &&
              <div className='web-pageCover'>
                <Page
                  pageLen={list.length % 10 === 0 ? list.length / 10 : Math.floor(list.length / 10) + 1}
                  setPageIndex={pageChange}
                />
              </div>
            }
          </div>
      }
    </div>

  )
}

export default RichRank;